module.exports = __webpack_public_path__ + "staticV3/img/61881355.empty-order.png";